import { Circle, HStack, Icon, IconButton } from '@chakra-ui/react'
import { ArrowLeft, ArrowRight } from 'react-feather'
import { useTranslation } from 'react-i18next'

import { CarouselState } from 'lib/hooks/useCarouselState'

interface ImageCarouselControlsProps {
  carouselState: CarouselState
  ariaControlsId: string
}

const ImageCarouselControls: React.FC<ImageCarouselControlsProps> = ({
  carouselState,
  ariaControlsId,
}) => {
  const { t } = useTranslation()
  const { selected, count, next, prev, atEnd, atBeginning } = carouselState

  return (
    <HStack spacing="6" pointerEvents="auto">
      <IconButton
        aria-label={t('imageCarousel.previousAriaLabel')}
        aria-controls="imageCarousel"
        icon={<Icon boxSize="6" as={ArrowLeft} />}
        disabled={atBeginning}
        onClick={prev}
        colorScheme="white"
        variant="ghost"
      />

      <HStack spacing="2">
        {Array(count)
          .fill(null)
          .map((_, index) => (
            <Circle
              key={index}
              bg={index === selected ? 'white' : 'dark'}
              border={index === selected ? '1px' : undefined}
              borderColor="offBlack"
              w="2"
              h="2"
            />
          ))}
      </HStack>

      <IconButton
        aria-label={t('imageCarousel.nextAriaLabel')}
        aria-controls={ariaControlsId}
        icon={<Icon boxSize="6" as={ArrowRight} />}
        disabled={atEnd}
        onClick={next}
        colorScheme="white"
        variant="ghost"
      />
    </HStack>
  )
}

export default ImageCarouselControls
